import { Flex, Icon, Text } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { COMMON_WEB_PATH } from "../../constant";
import { RiMenuSearchFill } from "react-icons/ri";
import { useTranslation } from "react-i18next";

const CasinoGroupLink = ({ wrapperClass, hiddenGameSearch = false } = {}) => {
  const { t } = useTranslation();

  const location = useLocation();

  return hiddenGameSearch ? null : (
    <Link
      to="casino-group"
      state={{
        from: location,
      }}
      className={`mb-4 block ${wrapperClass}`}
    >
      <Flex
        alignItems={`center`}
        justifyContent={`space-between`}
        gap="10px"
        maxW="250px"
        height="39px"
        bgImage={{
          base: `url('${COMMON_WEB_PATH}/FlyDragon/searchBG.webp')`,
          md: `url('${COMMON_WEB_PATH}/FlyDragon/game_BG.webp')`,
        }}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100%100%"
        px="10px"
      >
        <Text as="span">{t("common.search_games", "搜尋遊戲...")}</Text>

        <Icon as={RiMenuSearchFill} fontSize="2xl" className="mb-1" />
      </Flex>
    </Link>
  );
};

export default CasinoGroupLink;
